import { render, staticRenderFns } from "./education-card.vue?vue&type=template&id=ac7e16ea&scoped=true&"
import script from "./education-card.vue?vue&type=script&lang=js&"
export * from "./education-card.vue?vue&type=script&lang=js&"
import style0 from "./education-card.vue?vue&type=style&index=0&id=ac7e16ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7e16ea",
  null
  
)

export default component.exports